"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Security_1 = require("../connect/Security");
var WindowMode_1 = require("../models/WindowMode");
var Utils_1 = tslib_1.__importDefault(require("../utils/Utils"));
var DialogWindow = /** @class */ (function () {
    function DialogWindow() {
    }
    DialogWindow.openLoginDialog = function (clientId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var templateUrl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (options.idpHint) {
                    case 'google':
                        templateUrl = Utils_1.default.urls.connect + "/static/html/login-google-idp-hint.html";
                        break;
                    case 'apple':
                        templateUrl = Utils_1.default.urls.connect + "/static/html/login-apple-idp-hint.html";
                        break;
                    case 'twitter':
                    case 'arkane-twitter':
                        templateUrl = Utils_1.default.urls.connect + "/static/html/login-twitter-idp-hint.html";
                        break;
                    case 'facebook':
                    case 'arkane-facebook':
                        templateUrl = Utils_1.default.urls.connect + "/static/html/login-facebook-idp-hint.html";
                        break;
                    case 'password':
                        templateUrl = Utils_1.default.urls.connect + "/static/html/login-password-idp-hint.html";
                        break;
                    default:
                        templateUrl = Utils_1.default.urls.connect + "/static/html/login-none-idp-hint.html";
                        break;
                }
                return [2 /*return*/, new Promise(function (resolve) {
                        fetch(templateUrl)
                            .then(function (response) { return response.text(); })
                            .then(function (template) {
                            var overlayContainer = _this.createOverlayContainer();
                            var container = document.createElement('div');
                            var shadowRoot = container.attachShadow({ mode: 'open' });
                            container.classList.add('venly-connect-dialog-container');
                            shadowRoot.innerHTML = template;
                            container.style.position = 'absolute';
                            container.style.zIndex = '2147483647';
                            container.style.display = 'block';
                            container.style.top = "" + (window.innerWidth > 450 ? '0' : '50%');
                            container.style.left = "" + (window.innerWidth > 450 ? 'calc(50% - 200px)' : '50%');
                            var backdrop = document.createElement('div');
                            backdrop.classList.add('venly-connect-dialog-backdrop');
                            backdrop.style.position = 'fixed';
                            backdrop.style.width = '100%';
                            backdrop.style.height = '100%';
                            backdrop.style.zIndex = '2147483647';
                            backdrop.style.backdropFilter = 'blur(5px)';
                            var companyLogo = shadowRoot.querySelector('.connect-company-logo');
                            companyLogo.src = Utils_1.default.urls.storage + "/clients/logos/" + clientId + ".png";
                            overlayContainer.appendChild(backdrop);
                            _this.addFonts();
                            _this.addAnimationScript(shadowRoot);
                            var idpHint = options.idpHint;
                            if (idpHint === 'register') {
                                _this.showRefocusLayout();
                                Security_1.Security.login(clientId, tslib_1.__assign({}, options, { idpHint: idpHint, windowMode: WindowMode_1.WindowMode.POPUP })).then(function (authResult) {
                                    _this.removeBackdrop();
                                    _this.closeRefocusLayout();
                                    resolve(authResult);
                                });
                            }
                            else {
                                overlayContainer.appendChild(container);
                                _this.addAuthEventListeners(clientId, options, resolve, shadowRoot);
                                document.body.appendChild(overlayContainer);
                                _this.addCloseListeners(shadowRoot);
                            }
                        });
                    })];
            });
        });
    };
    DialogWindow.addFonts = function () {
        var style = Utils_1.default.urls.connect + "/static/css/connect/fonts.css";
        var stylesheet = document.createElement('link');
        stylesheet.setAttribute('rel', 'stylesheet');
        stylesheet.setAttribute('href', style);
        stylesheet.setAttribute('type', 'text/css');
        document.querySelector('head').appendChild(stylesheet);
    };
    DialogWindow.addAnimationScript = function (shadowRoot) {
        var lootieScript = document.createElement('script');
        lootieScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.10.2/lottie.min.js');
        lootieScript.setAttribute('integrity', 'sha512-fTTVSuY9tLP+l/6c6vWz7uAQqd1rq3Q/GyKBN2jOZvJSLC5RjggSdboIFL1ox09/Ezx/AKwcv/xnDeYN9+iDDA==');
        lootieScript.setAttribute('crossorigin', 'anonymous');
        lootieScript.setAttribute('referrerpolicy', 'no-referrer');
        document.querySelector('head').appendChild(lootieScript);
        var interval = setInterval(function () {
            var lt = lottie; // TS compiler trick
            if (lt) {
                lt.loadAnimation({
                    container: shadowRoot.querySelector('.animation'),
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: Utils_1.default.urls.connect + "/static/animations/login-animation.json"
                });
                clearInterval(interval);
            }
        }, 100);
    };
    DialogWindow.addAuthEventListeners = function (clientId, options, authResolver, root) {
        var _this = this;
        var authActions = root.querySelectorAll('.auth-action');
        Array.from(authActions).forEach(function (authAction) {
            authAction.addEventListener('click', function (event) {
                var idpHint = event.target.dataset.idpHint || event.target.parentElement.dataset.idpHint;
                Security_1.Security.login(clientId, tslib_1.__assign({}, options, { idpHint: idpHint, windowMode: WindowMode_1.WindowMode.POPUP })).then(function (authResult) {
                    _this.removeBackdrop();
                    _this.closeRefocusLayout(options.closePopup);
                    authResolver(authResult);
                });
                _this.closeLoginDialog();
                _this.showRefocusLayout();
            });
        });
        var selectAnotherOption = root.querySelector('.select-another-option');
        if (selectAnotherOption) {
            selectAnotherOption.addEventListener('click', function () {
                _this.closeLoginDialog();
                _this.removeBackdrop();
                delete options.idpHint;
                authResolver(_this.openLoginDialog(clientId, options));
            });
        }
    };
    DialogWindow.addCloseListeners = function (root) {
        var _this = this;
        var close = root.querySelector('.venly-connect-close-dialog');
        var backdrop = document.body.querySelector('.venly-connect-dialog-backdrop');
        if (close) {
            close.addEventListener('click', function () {
                _this.closeLoginDialog();
                _this.removeBackdrop();
            });
        }
        if (backdrop) {
            backdrop.addEventListener('click', function () {
                if (!Security_1.Security.hasPopupWindow()) {
                    _this.closeLoginDialog();
                    _this.removeBackdrop();
                    _this.closeRefocusLayout();
                }
            });
        }
    };
    DialogWindow.closeLoginDialog = function () {
        var dialogContainer = document.body.querySelector('.venly-connect-dialog-container');
        if (dialogContainer) {
            dialogContainer.remove();
        }
    };
    DialogWindow.removeBackdrop = function () {
        var backdrop = document.body.querySelector('.overlay-container');
        if (backdrop) {
            backdrop.remove();
        }
    };
    DialogWindow.showRefocusLayout = function () {
        var _this = this;
        fetch(Utils_1.default.urls.connect + "/static/html/re-focus-layout.html")
            .then(function (response) { return response.text(); })
            .then(function (template) {
            var overlayContainer = _this.createOverlayContainer();
            var container = document.createElement('div');
            var shadowRoot = container.attachShadow({ mode: 'open' });
            container.classList.add('venly-connect-refocus-container');
            shadowRoot.innerHTML = template;
            container.style.position = 'absolute';
            container.style.top = 'calc(50% - 218px)';
            container.style.left = 'calc(50% - 147.5px)';
            container.style.zIndex = '2147483647';
            overlayContainer.appendChild(container);
            document.body.appendChild(overlayContainer);
            _this.addRefocusListeners(shadowRoot);
        });
    };
    DialogWindow.closeRefocusLayout = function (closePopup) {
        if (closePopup === void 0) { closePopup = true; }
        var backdrop = document.body.querySelector('.overlay-container');
        if (closePopup)
            Security_1.Security.closePopupWindow();
        if (backdrop) {
            backdrop.remove();
        }
    };
    DialogWindow.addRefocusListeners = function (root) {
        var reopenAction = root.querySelector('.venly-connect-re-focus-wrapper .reopen-action');
        if (reopenAction) {
            reopenAction.addEventListener('click', function () { return Security_1.Security.focusPopupWindow(); });
        }
    };
    DialogWindow.createOverlayContainer = function () {
        var overlayContainer = document.createElement('div');
        overlayContainer.classList.add('overlay-container');
        overlayContainer.style.position = 'fixed';
        overlayContainer.style.zIndex = '2147483647';
        overlayContainer.style.top = '0';
        overlayContainer.style.left = '0';
        overlayContainer.style.height = '100%';
        overlayContainer.style.background = 'rgba(33, 37, 41, 0.5)';
        overlayContainer.style.width = '100%';
        return overlayContainer;
    };
    return DialogWindow;
}());
exports.DialogWindow = DialogWindow;
//# sourceMappingURL=DialogWindow.js.map